import { h, Host } from "@stencil/core";
export class CheckboxListItem {
    constructor() {
        this.value = undefined;
        this.label = undefined;
        this.name = "";
        this.checked = false;
        this.disabled = false;
        this.errorMsg = undefined;
        this.error = false;
        this.inputId = null;
    }
    element;
    /**
     redispatches the uxCheckboxChange event, otherwise not interceptable in SPAs
     */
    checkboxListItemEvent;
    dispatchCheckboxListItemChange = (e) => {
        this.checkboxListItemEvent.emit(e.detail);
    };
    render() {
        const baseClass = "ux-checkbox-list-item";
        return (h(Host, { key: '4116d855f5891ce790e2e756ff56088dad314322', class: baseClass }, h("ux-checkbox", { key: '7109ecb917c2c03c2ad0375493b6c65371778abe', value: this.value, label: this.label, name: this.name, checked: this.checked, disabled: this.disabled, onUxCheckboxChange: this.dispatchCheckboxListItemChange, error: this.error, errorMsg: this.errorMsg,
            // @ts-expect-error Check for typing
            inputId: this.inputId || null }, h("slot", { key: 'd02d14c764f8915a65811db4cdf3c889d0f1b3d4' }))));
    }
    static get is() { return "ux-checkbox-list-item"; }
    static get originalStyleUrls() {
        return {
            "$": ["checkbox-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["checkbox-list-item.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "this value is used on the checkbox inside this item"
                },
                "attribute": "value",
                "reflect": true
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the label that is displayed for this item inside the dropdown"
                },
                "attribute": "label",
                "reflect": true
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name which is used for checkbox groups or as identifier in forms"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox is checked"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox has an error state"
                },
                "attribute": "error-msg",
                "reflect": false
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the checkbox has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the inputId to be passed down to the ux-checkbox"
                },
                "attribute": "input-id",
                "reflect": false,
                "defaultValue": "null"
            }
        };
    }
    static get events() {
        return [{
                "method": "checkboxListItemEvent",
                "name": "uxCheckboxListItemChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "redispatches the uxCheckboxChange event, otherwise not interceptable in SPAs"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=checkbox-list-item.js.map
